module.exports = __webpack_public_path__ + "img/编辑色块.19bf9048.svg";